import styled from "styled-components";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import SystemSettings from "./Settings/SystemSettings";
import SystemStructure from "./Settings/SystemStructure";
import UsersAndRulesSettings from "./Settings/UsersAndRules";
import BranchSettings from "./Settings/BranchSettings";
import GeneralTables from "./Settings/GeneralTables";
import UnknownPage from "../../components/UnknownPage";
import FormSelect from "../../components/FormControls/FormSelect";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const StyledBoard = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    background-color: ${(props) => props.theme.color.lightgray};
    padding: 45px;
    height: calc(100vh - 210px);
    overflow: auto;


`;

const PageContent = styled.div`
    width: 1000px;
    margin: auto;
`;

const BoardHeader = styled.div`
    width: 1000px;
    display: flex;
    margin: auto;
    padding-bottom: 15px;
`;

const Database = styled.div`
    display: flex;
    font-size: 12px;
    margin-top: auto;
`;

const DBLabel = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 700;
`;

const DBName = styled.span`
    color: ${(props) => props.theme.color.gray};
    padding-left: 5px;
    font-weight: 600;
`;

const PageTitle = styled.span`
    font-size: 20px;
    font-weight: 600;
    padding-left: 30px;
    color: ${(props) => props.theme.color.dark};
    margin-top: auto;
`;

const SmallPageTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    padding-left: 10px;
    color: ${(props) => props.theme.color.primaryblue};
    margin-top: auto;
`;

const BaseYear = styled.div`
    display: flex;
    font-size: 12px;
    margin-top: auto;
    margin-left: auto;
    align-items: center;
    color: ${(props) => props.theme.color.gray};
`;

const BaseYearLabel = styled.span`
    font-weight: 600;
`;

function Board(props) {

    let currentYear = new Date().getFullYear();
    const [loadedPage, setLoadedPage] = useState(false);
    const [leftPaneWidth, setLeftPaneWidth] = useState(215);

    const location = useLocation();

    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    const onBaseYearChange = (e) => {
        props.setBaseYear(parseInt(e.target.value));
    }

    useEffect(() => {
        if (location.pathname.includes('/settings/branch') || location.pathname.includes('/settings/usersettings')) {
            setLeftPaneWidth(369);
        } else {
            setLeftPaneWidth(215);
        }
    });

    useEffect(() => {
        if (!loadedPage) {
            props.setBaseYear(currentYear);
            setLoadedPage(true);
        }
    }, []);

    return (
        <StyledBoard>
            <BoardHeader>
                <Database style={{width:leftPaneWidth}}>
                    <DBLabel>Database</DBLabel>
                    <DBName>{props.databaseName}</DBName>
                </Database>
                <PageTitle>{props.pageTitle}</PageTitle>
                <SmallPageTitle>{props.smallPageTitle}</SmallPageTitle>
                <BaseYear>
                    <BaseYearLabel>Base year</BaseYearLabel>
                    <FormSelect items={years} value={props.baseYear} onChange={(e) => onBaseYearChange(e)} style={{display: 'flex', minWidth: 80, marginLeft: 15, paddingLeft: 7, paddingTop: 2, paddingBottom: 2}}></FormSelect>
                </BaseYear>
            </BoardHeader>
            <PageContent>
                <Routes>
                    <Route path="/" element={<Navigate to='/homepage' />}/>
                    <Route path="/settings/system/*" element={<SystemSettings {...props}/>}/>
                    <Route path="/settings/system/:subPagePath" element={<SystemSettings {...props}/>}/>

                    <Route path="/systemstructure/*" element={<SystemStructure {...props}/>}/>
                    <Route path="/systemstructure/:subPagePath/:subTabPath" element={<SystemStructure {...props}/>}/>
                    <Route path="/systemstructure/:subPagePath/*" element={<SystemStructure {...props}/>}/>

                    <Route path="/settings/branch/*" element={<BranchSettings {...props}/>}/>
                    <Route path="/settings/branch/:subTabPath" element={<BranchSettings {...props}/>}/>

                    <Route path="/settings/usersettings/*" element={<UsersAndRulesSettings {...props}/>}/>
                    <Route path="/settings/usersettings/:subTabPath" element={<UsersAndRulesSettings {...props}/>}/>

                    <Route path="/generaltables/*" element={<GeneralTables {...props}/>}/>
                    <Route path="/generaltables/:subPagePath" element={<GeneralTables {...props}/>}/>

                    <Route path="*" element={<UnknownPage/>}/>
                </Routes>
            </PageContent>
            <NotificationContainer/>
        </StyledBoard>
    )
}

export default Board;